package com.fantasytenis.shared.data.admin.api

import com.fantasytenis.shared.core.network.ApiResponse
import com.fantasytenis.shared.core.network.WrappedResponse
import com.fantasytenis.shared.data.admin.dto.PlatformConfigDto
import com.fantasytenis.shared.data.admin.dto.UpdatePlatformConfigRequest
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

/**
 * Admin API client.
 *
 * Handles platform administration HTTP requests.
 */
class AdminApi(
    private val httpClient: HttpClient,
    private val baseUrl: String
) {

    /**
     * Get platform configuration.
     * This is a public endpoint - all users can read config.
     */
    suspend fun getConfig(): ApiResponse<PlatformConfigDto> {
        return try {
            val response = httpClient.get("${baseUrl}admin/config")

            if (response.status.isSuccess()) {
                val wrapped = response.body<WrappedResponse<PlatformConfigDto>>()
                if (wrapped.data != null) {
                    ApiResponse.Success(wrapped.data)
                } else {
                    ApiResponse.Error(wrapped.error?.message ?: "Failed to get config", response.status.value)
                }
            } else {
                val wrapped = response.body<WrappedResponse<PlatformConfigDto>>()
                ApiResponse.Error(wrapped.error?.message ?: "Failed to get config", response.status.value)
            }
        } catch (e: Exception) {
            ApiResponse.Error(e.message ?: "Network error", 0)
        }
    }

    /**
     * Update platform configuration.
     * Only admins/superadmins can call this endpoint.
     */
    suspend fun updateConfig(request: UpdatePlatformConfigRequest): ApiResponse<PlatformConfigDto> {
        return try {
            val response = httpClient.put("${baseUrl}admin/config") {
                contentType(ContentType.Application.Json)
                setBody(request)
            }

            if (response.status.isSuccess()) {
                val wrapped = response.body<WrappedResponse<PlatformConfigDto>>()
                if (wrapped.data != null) {
                    ApiResponse.Success(wrapped.data)
                } else {
                    ApiResponse.Error(wrapped.error?.message ?: "Failed to update config", response.status.value)
                }
            } else {
                val wrapped = response.body<WrappedResponse<PlatformConfigDto>>()
                ApiResponse.Error(wrapped.error?.message ?: "Failed to update config", response.status.value)
            }
        } catch (e: Exception) {
            ApiResponse.Error(e.message ?: "Network error", 0)
        }
    }
}
